export const frontendAccessRules = {
    '/admin/users': ['siteadmin', 'admin'],
    '/admin/childcare-staff': ['siteadmin', 'admin', 'childcare'],
    '/admin/church-staff': ['siteadmin', 'admin', 'church'],
    '/admin/dashboard': ['siteadmin', 'admin', 'church', 'childcare'],
    '/admin/messages': ['siteadmin', 'admin', 'church'],
    '/admin/past-sessions': ['siteadmin', 'admin', 'church'],
    '/admin/daily-readings': ['siteadmin', 'admin', 'church'],
    '/admin/verse-of-the-day': ['siteadmin', 'admin', 'church'],
    '/admin/announcements': ['siteadmin', 'admin', 'church'],
    '/admin/operation-christmas-child': ['siteadmin', 'admin', 'church'],
    '/admin/first-responders': ['siteadmin', 'admin', 'church'],
    '/admin/mission-trips': ['siteadmin', 'admin', 'church'],
    '/admin/common-grounds': ['siteadmin', 'admin', 'church'],
    '/admin/holidays': ['siteadmin', 'admin', 'church'],
    '/admin/september-club': ['siteadmin', 'admin', 'church'],
    '/admin/feature-requests': ['siteadmin', 'admin', 'church']
};